import React, { useState } from "react";
import { Button, Menu, MenuItem } from "@mui/material";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";

const ApplyDropdown = () => {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <div>
      <Button
        id="apply-button"
        aria-controls={open ? "apply-menu" : undefined}
        aria-haspopup="true"
        aria-expanded={open ? "true" : undefined}
        onClick={handleClick}
        color="inherit"
        endIcon={<ArrowDropDownIcon />}
      >
        Apply
      </Button>
      <Menu
        id="apply-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          "aria-labelledby": "apply-button",
        }}
      >
        <MenuItem onClick={handleClose}>Subsidy Overview</MenuItem>
        <MenuItem onClick={handleClose}>Apply for Subsidy</MenuItem>
      </Menu>
    </div>
  );
};

export default ApplyDropdown;
